export enum VariableDisplay {
    Required = 'Required',
    Optional = 'Optional',
    Hidden = 'Hidden',
}
